/* VNSTRA: toont op de folie-productpagina wat de rekenhulp op de collectie uitrekende (09-10-2026).
   Leest sessionStorage 'vnstraRekenhulp' ({vellen, deurtjes}); schrijft niets.
   Knop zet het aantal in het aantal-veld van het productformulier. Geen externe scripts. */
(function () {
  'use strict';
  function init() {
    var box = document.querySelector('[data-vnstra-calcnote]');
    if (!box) return;
    var data = null;
    try { data = JSON.parse(window.sessionStorage.getItem('vnstraRekenhulp') || 'null'); } catch (e) { data = null; }
    if (!data || !(data.vellen > 0)) return;
    var vellen = Math.round(data.vellen);
    var deur = Math.round(data.deurtjes || 0);
    var res = box.querySelector('[data-vnstra-calcnote-res]');
    var ask = box.querySelector('[data-vnstra-calcnote-ask]');
    var txt = box.querySelector('[data-vnstra-calcnote-txt]');
    var n = box.querySelector('[data-vnstra-calcnote-n]');
    var btn = box.querySelector('[data-vnstra-calcnote-btn]');
    if (!res || !txt || !btn) return;
    txt.textContent = 'Je rekenhulp gaf ' + vellen + (vellen === 1 ? ' vel' : ' vellen') +
      (deur > 0 ? ' voor ' + deur + (deur === 1 ? ' deurtje' : ' deurtjes') : '') + '.';
    if (n) n.textContent = String(vellen);
    res.hidden = false;
    if (ask) ask.hidden = true;
    btn.addEventListener('click', function () {
      var scope = box.closest('[id^="shopify-section"]') || document;
      /* Zet het aantal in het productformulier én in de sticky koopbalk (fix 09-10-2026). */
      var qs = scope.querySelectorAll('input[name="quantity"]');
      if (!qs.length) qs = document.querySelectorAll('form[action*="/cart/add"] input[name="quantity"]');
      if (!qs.length) return;
      for (var i = 0; i < qs.length; i++) {
        qs[i].value = String(vellen);
        qs[i].dispatchEvent(new Event('input', { bubbles: true }));
        qs[i].dispatchEvent(new Event('change', { bubbles: true }));
      }
      btn.textContent = 'Aantal staat op ' + vellen;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
